export default "__VITE_ASSET__ChAXNBia__"